/** Must match `SCOUT_PRIVATE_DOCUMENT_EXTRACTION_WATCH_URL_PREFIX` in encamp-scout-connection. */
export const SCOUT_PRIVATE_DOCUMENT_EXTRACTION_WATCH_URL_PREFIX =
  "encamp-private-document-extraction://";

const SCOUT_EXTRACTION_WATCH_MARKER_PATTERN = /\[scout-extraction-watch:([0-9a-f-]{36})\]/gi;

export function buildScoutPrivateDocumentExtractionWatchPartUrl(privateDocumentId: string): string {
  return `${SCOUT_PRIVATE_DOCUMENT_EXTRACTION_WATCH_URL_PREFIX}${privateDocumentId}`;
}

export function isScoutPrivateDocumentExtractionWatchPartUrl(
  url: string | null | undefined
): boolean {
  return url?.startsWith(SCOUT_PRIVATE_DOCUMENT_EXTRACTION_WATCH_URL_PREFIX) ?? false;
}

export function formatScoutExtractionWatchUserMessage(privateDocumentIds: string[]): string {
  if (privateDocumentIds.length === 1) {
    return `Start the full analysis.\n[scout-extraction-watch:${privateDocumentIds[0]}]`;
  }

  const markers = privateDocumentIds.map(
    (privateDocumentId) => `[scout-extraction-watch:${privateDocumentId}]`
  );
  return `Start full analysis on all attached documents.\n${markers.join("\n")}`;
}

export function parseScoutExtractionWatchDocumentIdFromText(
  text: string | null | undefined
): string | undefined {
  return parseScoutExtractionWatchDocumentIdsFromText(text)[0];
}

export function parseScoutExtractionWatchDocumentIdsFromText(
  text: string | null | undefined
): string[] {
  if (!text) {
    return [];
  }

  const matches = [...text.matchAll(/\[scout-extraction-watch:([0-9a-f-]{36})\]/gi)];
  return matches.map((match) => match[1]).filter((value): value is string => value !== undefined);
}

export function stripScoutExtractionWatchMarkerFromText(text: string): string {
  return text.replace(SCOUT_EXTRACTION_WATCH_MARKER_PATTERN, "").trim();
}
